import { render } from "./Contact.vue?vue&type=template&id=1e5210b4"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=1e5210b4&lang=css"

import exportComponent from "D:\\케이터링\\html(JW 가상화서버)\\justinfood\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__